export function serviceListing() {
    gsap.registerPlugin(ScrollTrigger)
    // services listing
    if (document.querySelector(".section-services-list")) {
        gsap.set(".section-services-list a.btn", { opacity: 1, transition: "none" })
        gsap.timeline({
            scrollTrigger: {
                trigger: ".section-services-list",
                start: "top 85%",
                scrub: false,
            },
        })
            .from(".section-services-list h3", {
                opacity: 0,
                duration: 1,
            })
            .from(
                ".section-services-list ul.services-list li",
                {
                    opacity: 0,
                    duration: 1,
                    stagger: 0.1,
                },
                "<+0.1"
            )
            .from(
                ".section-services-list a.btn",
                {
                    opacity: 0,
                    duration: 1,
                },
                ">-0.9"
            )
    }
}
